<template>
	<loader v-if="!formReady"/>
	<form v-else class="wide sections" @submit.prevent="submit">
		<section class="section--floating section--full">
			<fieldset>
				<div>
					<div>
						<legend><span>Details</span></legend>
					</div>
					<div>
						<label><span>Name </span>
							<div v-if="form.errors.get('name')" class="error-block">
								<p v-html="form.errors.get('name')"/>
							</div>
							<input v-model="form.data.name" type="text">
						</label>
						<label><span>Description </span>
							<div v-if="form.errors.get('description')" class="error-block">
								<p v-html="form.errors.get('description')"/>
							</div>
							<textarea v-model="form.data.description"></textarea>
						</label>
						<label><span>Products </span>
							<div v-if="form.errors.get('products')" class="error-block">
								<p v-html="form.errors.get('products')"/>
							</div>
							<checkbox-manager
								:all-items="form.options.products"
								:checked="form.optionsByFieldArray('products', 'products')"
								helpBlock="Move the products that <em>are included in this bundle </em>into the right hand column or vice versa."
								itemLabel="name"
								v-on:valuesChanged="(items) => form.set('products', items)"/>
						</label>
					</div>
				</div>
			</fieldset>
			<div class="actions">
				<ul>
					<li>
						<process-button
							:processing="form.processing" :text="$attrs.cta" class="button button--primary"/>
					</li>
				</ul>
			</div>
		</section>
	</form>
</template>
<script>

export default {
	data() {
		return {
			formReady: false,
			form: this.newForm({
				name: "",
				description: "",
				products: [],
			}),
		};
	},

	props: {
		searchPackBundle: null,
		method: {
			type: String,
			default() {
				return "post";
			},
		},
	},

	methods: {
		async submit() {
			if ("post" === this.method) {
				this.form.post("search-pack-bundles").then(data => {
					this.$router.push({name: "searchPackBundles.index"});
					this.$store.dispatch("alertsStore/success", "Bundle Created");
				});
			}

			if ("patch" === this.method) {
				this.form.patch(this.route("search-pack-bundles/:searchPackBundle", this.searchPackBundle)).then(data => {
					this.$router.push({name: "searchPackBundles.index"});
					this.$store.dispatch("alertsStore/success", "Bundle Updated");
				});
			}
		},
	},

	created() {
		http().get("form-data/search-pack-bundle").then(response => {
			this.form.setOptions(response.data);

			if (this.searchPackBundle) {
				this.form.prefill(this.searchPackBundle);

				this.form.set("products", _.map(this.searchPackBundle.products, function (product) {
					return product.id;
				}));
			}

			this.formReady = true;
		});
	},
};
</script>
